var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSurgicalMask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.228,372.771H90.944C40.797,372.771,0,331.973,0,281.827c0-44.362,30.63-82.046,74.21-89.603   c5.987-1.035,11.68,2.973,12.718,8.959c1.038,5.985-2.973,11.679-8.959,12.717C44.959,219.625,22,248.192,22,281.827   c0,38.016,30.928,68.944,68.944,68.944h40.284c6.075,0,11,4.925,11,11S137.303,372.771,131.228,372.771z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M421.056,372.771h-40.244c-6.075,0-11-4.925-11-11s4.925-11,11-11h40.244c38.016,0,68.944-30.929,68.944-68.944   c0-33.66-22.923-62.214-55.884-67.895c-5.987-1.031-10.004-6.721-8.972-12.708c1.032-5.986,6.722-10.009,12.708-8.972   C481.396,199.757,512,237.427,512,281.827C512,331.973,471.203,372.771,421.056,372.771z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M315.099,266.32H196.975c-6.075,0-11-4.925-11-11s4.925-11,11-11h118.124c6.075,0,11,4.925,11,11   S321.174,266.32,315.099,266.32z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M292.287,335.415h-72.573c-6.075,0-11-4.925-11-11s4.925-11,11-11h72.573c6.075,0,11,4.925,11,11   S298.362,335.415,292.287,335.415z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#33CCCC"
    },
    d: "M256.037,422.5c-104.737,0-189.947-85.21-189.947-189.947v-70.428c0-6.075,4.925-11,11-11   c27.227,0,49.378-22.151,49.378-49.378c0-0.131-0.006-0.26-0.011-0.39l-0.019-0.637c-0.059-2.955,1.074-5.81,3.143-7.92   s4.9-3.3,7.855-3.3h237.202c2.958,0,5.791,1.191,7.86,3.305c2.068,2.113,3.199,4.971,3.138,7.928l-0.02,0.629   c-0.004,0.128-0.011,0.256-0.011,0.385c0,27.227,22.151,49.378,49.379,49.378c6.075,0,11,4.925,11,11v70.428   C445.985,337.29,360.774,422.5,256.037,422.5z M88.089,172.278v60.274c0,92.606,75.341,167.947,167.947,167.947   c92.607,0,167.948-75.341,167.948-167.947v-60.274c-30.982-4.812-55.439-29.623-59.715-60.777H147.803   C143.528,142.655,119.071,167.466,88.089,172.278z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurgicalMask);
export default __webpack_public_path__ + "static/media/surgical-mask.1d57ce97772e5a32a16f6fb6aa0282dd.svg";
export { ForwardRef as ReactComponent };